// constants
import { commonImage } from 'constants/images';

// libraries
import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledCenterModal = styled(Box)`
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  background: var(--color-white);

  .center-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid var(--color-border-light-gray);
    box-sizing: border-box;
    padding: 20px 28px;

    &-close {
      background-image: url(${commonImage.modalClose});
      background-size: contain;
      background-repeat: no-repeat;
      transform: translateY(8px);
      margin-left: auto;
      width: 24px !important;
      border: none !important;
      box-shadow: none !important;
      min-width: 24px !important;
    }
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 28px 24px;
  gap: 12px;

  > button {
    min-width: fit-content !important;
    width: fit-content !important;
    text-transform: capitalize;
  }
`;
